import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {LangService} from "../shared/services/lang.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Person} from "./models/person.model";
import {Subscription} from "rxjs";
import {TrackService} from "./services/track.service";
import {TrackrespModel} from "./models/trackresp.model";
import {DatePipe} from "@angular/common";
import {ModalDirective} from "ngx-bootstrap/modal";

@Component({
  selector: 'app-track',
  templateUrl: './track.component.html',
  styleUrls: ['./track.component.css']
})
export class TrackComponent implements OnInit, OnDestroy {

  @ViewChild('errorModal', {static: true}) errorModal: ModalDirective;

  show: Boolean = false;
  passportForm: FormGroup;
  subscription: Subscription;
  spinner: Boolean = true;
  trackResp: TrackrespModel = null;
  error: any;

  constructor(private router: Router,
              private fb: FormBuilder,
              private datePipe: DatePipe,
              private langService: LangService,
              private trackService: TrackService,
              private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.passportForm = this.fb.group({
      nom: ['', Validators.required],
      dateNaissance: ['', Validators.required],
      numCarteConsulaire: ['', Validators.required],
      numPersonnel: ['', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9]{15}$/)
      ]]
    });

    this.route.queryParams.subscribe(params => {

      if (params) {
        this.passportForm.patchValue({
          nom: params['lastName'] ?? '',
          numCarteConsulaire: params['cid'] ?? '',
          dateNaissance: this.datePipe.transform(params['birthDay'], "yyyy-MM-dd")
        });
      }
    });
  }

  onRedirectlogin() {
    window.open('/account', '_self');
  }

  onRedirectHome() {
    this.router.navigateByUrl('home');
  }

  onSubmit(): void {
    this.spinner = false;
    const newPerson: Person = {
      uid: this.passportForm.value.numPersonnel,
      cid: this.passportForm.value.numCarteConsulaire,
      birthDay: this.datePipe.transform(this.passportForm.value.dateNaissance, 'dd/MM/yyyy'),
      lastName: this.passportForm.value.nom
    };
    this.subscription = this.trackService.track(newPerson).subscribe(
      (resp: TrackrespModel) => {
        this.trackResp = resp;
        if (this.trackResp.data == null && this.trackResp.errorCode === 409) {
          this.error = "409_ERROR";
          this.showModal();
        } else if (this.trackResp.data == null && this.trackResp.errorCode !== 0) {
          this.error = "500_ERROR";
          this.showModal();
        }
      },
      (error) => {
        // alert("Une erreur inconnue est survenue !");
        this.spinner = true;
        this.error = "500_ERROR";
        this.showModal();
      },
      () => {
        this.spinner = true;
      });
  }

  showModal(): void {
    this.errorModal.show();
  }

  hideModal() {
    this.errorModal.hide();
  }

  ngOnDestroy(): void {
    if (this.subscription !== undefined) {
      this.subscription.unsubscribe();
    }
  }
}
